import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import clsx from 'clsx';
import css from './ReCaptchaValidator.module.css';
import { EnvironmentExtended } from '../../environment/index';
import {
  StackedColumn,
  StackedColumnSpacing,
  ValidationMessage,
} from '../../core';
import { ReCaptchaState } from './ReCaptchaState';

export interface ReCaptchaValidatorProps {
  reCaptchaRef: React.RefObject<ReCAPTCHA>;
  reCaptchaState: ReCaptchaState;
  onReCaptchaChange: () => void;
}

const ReCaptchaValidator: React.FC<ReCaptchaValidatorProps> = (
  props: ReCaptchaValidatorProps
) => {
  return (
    <StackedColumn spacing={StackedColumnSpacing.NoGap}>
      <div>
        <div
          className={clsx(
            css.recaptchaContainer,
            props.reCaptchaState !== ReCaptchaState.OK
              ? css.recaptchaError
              : null
          )}
        >
          <ReCAPTCHA
            sitekey={EnvironmentExtended.getReCAPTCHASiteKey()}
            ref={props.reCaptchaRef}
            onChange={() => props.onReCaptchaChange()}
          />
        </div>
      </div>
      <div className={css.recaptchaValidation}>
        {props.reCaptchaState === ReCaptchaState.Error_Unchecked ? (
          <ValidationMessage errorMessage="reCAPTCHA is required. Please check the box." />
        ) : props.reCaptchaState === ReCaptchaState.Error_Failed ? (
          <ValidationMessage errorMessage="reCAPTCHA failed. Please try again." />
        ) : null}
      </div>
    </StackedColumn>
  );
};

export default ReCaptchaValidator;
